module.exports = __webpack_public_path__ + "img/icon-astra-lab.734d4f3c.png";